<template>
<message-bubble :isMine=isMine>
  <div class="custom-element-wrapper">
    <div class="survey"  v-if="this.payload.data === 'survey'">
      <el-rate
          v-model="rate"
          disabled
          show-score
          text-color="#ff9900"
          score-template="{value}">
      </el-rate>
      <div class="suggestion">{{this.payload.extension}}</div>
    </div>
    <custom-type1 v-else-if="JSON.parse(this.payload.data).type===1" :payload="payload"></custom-type1>
    <custom-type2  v-else-if="JSON.parse(this.payload.data).type===2" :payload="payload"></custom-type2>
    <custom-type3  v-else-if="JSON.parse(this.payload.data).type===3" :payload="payload"></custom-type3>
    <span  v-else-if="JSON.parse(this.payload.data).type===4" :payload="payload">4</span>
    <custom-type5  v-else-if="JSON.parse(this.payload.data).type===5"  :payload="payload"></custom-type5>
    <custom-type6  v-else-if="JSON.parse(this.payload.data).type===6"  :payload="payload"></custom-type6>
    <span class="text" title="您可以自行解析自定义消息" v-else  v-html="text">自定义消息</span>
  </div>
</message-bubble>
</template>

<script>
import MessageBubble from '../message-bubble'
import { Rate } from 'element-ui'
import customType1 from "./custom-type1"
import customType2 from "./custom-type2"
import customType3 from "./custom-type3"
import customType5 from "./custom-type5"
import customType6 from "./custom-type6"
import Vue from "vue"
export default {
  name: 'CustomElement',
  props: {
    payload: {
      type: Object,
      required: true
    },
    isMine: {
      type: Boolean
    }
  },
  components: {
    MessageBubble,
    ElRate: Rate,
    customType1,
    customType2,
    customType3,
    customType5,
    customType6
  },
  computed: {
    text() {
      return this.translateCustomMessage(this.payload)
    },
    rate() {
      console.log(this.payload)
      return parseInt(this.payload.description)
    }
  },
  methods: {
    translateCustomMessage(payload) {
      console.log((payload))
      if (payload.data === 'group_create') {
        return `${payload.extension}`
      }else{
        return "自定义消息"
      }
      
    }
  }

}
</script>

<style lang="stylus" scoped>
.text
  font-weight bold
.title
  font-size 16px
  font-weight 600
  padding-bottom 10px
.survey
  background-color white
  color black
  padding 20px
  display flex
  flex-direction column
.suggestion
  padding-top 10px
  font-size 14px

</style>
